import { Flex, Show } from "@chakra-ui/react";
import UTMLink from "@components/UTMLink";
import React from "react";

import { trackEvent } from "@lib/utils";
import { BANNER_CLICKED } from "@constants/analytics";
import BaseImage from "@components/BaseImage";

const DashboardBanner = () => {
  return (
    <UTMLink
      href="https://kerneldao.com/gain/"
      isExternal
      onClick={() =>
        trackEvent(BANNER_CLICKED, {
          Location: "dashboard",
          redirect_url: "https://kerneldao.com/gain/",
        })
      }
    >
      <Flex
        overflow="hidden"
        className="w-full"
        h={{ base: "143px", md: "142px", lg: "142px", xl: "142px" }}
        borderRadius="16px"
        position="relative"
      >
        <Show above="md">
          <BaseImage
            key="dasboard_banner"
            src="/assets/dashboard/banner.png"
            alt="image banner"
            width={872}
            height={154}
            layout="responsive"
          />
        </Show>
        <Show below="md">
          <BaseImage
            key="dasboard_banner"
            src="/assets/dashboard/banner_mobile.png"
            alt="image banner"
            width={984}
            height={366}
            layout="responsive"
          />
        </Show>
      </Flex>
    </UTMLink>
  );
};

export default DashboardBanner;
